import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Try window first
    if (window) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }

    // If your content is inside a specific container
    const scrollContainer = document.querySelector(".app-background");
    if (scrollContainer) {
      scrollContainer.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname]);

  return null;
}
